import * as Taro from '@tarojs/taro';
import click from '@/assets/audio/click.wav';
import eliminate from '@/assets/audio/eliminate.wav';
import shuffle from '@/assets/audio/shuffle.wav';
import win from '@/assets/audio/win.wav';
import lose from '@/assets/audio/lose.wav';
import bgm from '@/assets/audio/bgm.wav';

export type SoundType = 'click' | 'eliminate' | 'shuffle' | 'win' | 'lose' | 'bgm';
const sources = { click, eliminate, shuffle, win, lose, bgm };
class SoundManager {
  private enabled = true;
  private musicEnabled = false;
  private playing = false;
  private bgmPlaying = false;
  private contexts: Partial<Record<SoundType, Taro.InnerAudioContext>> = {};
  private context(type: SoundType) {
    if (typeof Taro.createInnerAudioContext !== 'function') return undefined;
    if (!this.contexts[type]) {
      const context = Taro.createInnerAudioContext();
      context.src = sources[type];
      context.loop = type === 'bgm';
      context.volume = type === 'bgm' ? .35 : .45;
      context.obeyMuteSwitch = true;
      context.onError(() => { if (type === 'bgm') this.bgmPlaying = false; });
      this.contexts[type] = context;
    }
    return this.contexts[type];
  }
  configure(enabled: boolean, musicEnabled: boolean) {
    this.enabled = enabled; this.musicEnabled = musicEnabled;
    if (!enabled) for (const [kind, context] of Object.entries(this.contexts)) if (kind !== 'bgm') context.stop();
    this.syncMusic();
  }
  setPlaying(playing: boolean) { this.playing = playing; this.syncMusic(); }
  private syncMusic() {
    if (this.musicEnabled && this.playing) {
      if (!this.bgmPlaying) { const context = this.context('bgm'); if (context) { context.play(); this.bgmPlaying = true; } }
    } else { this.contexts.bgm?.pause(); this.bgmPlaying = false; }
  }
  play(type: SoundType) {
    if (type === 'bgm') { this.syncMusic(); return; }
    if (!this.enabled) return;
    const context = this.context(type);
    context?.stop(); context?.play();
  }
  stop() {
    this.playing = false; this.bgmPlaying = false;
    Object.values(this.contexts).forEach(context => context.stop());
  }
}
export default new SoundManager();
